import styled from 'styled-components';
import {
  color3,
  colorBlack900,
  colorGrey400,
  fontFamilyPrimary,
  fontFamilySecondary,
} from 'styles';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';
import { Paragraph } from 'components/Typography';

export const Wrapper = styled(SectionWrapper)`
  margin-bottom: 16px;
`;

export const NewsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const Title = styled.h4`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 8px;
`;

export const NewsItem = styled.a`
  display: block;
  width: 100%;
  padding: 16px 0;
  cursor: pointer;

  &:not(:last-child) {
    border-bottom: 1px solid ${color3};
  }

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.9;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const NewsText = styled(Paragraph)`
  line-height: 20px;
  color: ${colorBlack900};
`;

export const NewsUpdate = styled.span`
  display: inline-block;
  margin-bottom: 4px;
  line-height: 18px;
  font-family: ${fontFamilyPrimary};
  font-size: 13px;
  color: ${colorGrey400};

  svg {
    margin-top: -3px;
  }
`;
